var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_596_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9126 11.9748L39.9439 4.94348H7.69328C7.16317 4.95674 6.65924 5.17668 6.28905 5.55636C5.91886 5.93604 5.71175 6.44538 5.71191 6.97566V40.6082C5.71191 41.1471 5.92602 41.664 6.30712 42.0451C6.68823 42.4262 7.20512 42.6403 7.74409 42.6403H41.3766C41.9156 42.6403 42.4324 42.4262 42.8136 42.0451C43.1947 41.664 43.4088 41.1471 43.4088 40.6082V15.4397L39.9439 18.9045M33.0142 11.9748L39.9439 18.9045L27.8525 30.8537L17.3969 34.3897L20.8923 23.9646L33.0142 11.9748Z",
    stroke: "#828282",
    strokeWidth: 1.5707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_596_266",
    x: -3,
    y: 0.230957,
    width: 55.1211,
    height: 55.1211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_596_266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_596_266",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderIcon);
export default __webpack_public_path__ + "static/media/SliderIcon.481c1a804bfa40d9ce303f62e55afb70.svg";
export { ForwardRef as ReactComponent };